const APPLICATION_STATUS_TYPE = {
  ACCEPTED: 'accepted',
  COMPLETED: 'completed',
  INVITED: 'invited',
  INVITED_TO_APPLY: 'invited to apply',
  IN_PROGRESS: 'in-progress',
  PENDING: 'pending',
  RECEIVED: 'received',
  WITHDRAWN: 'withdrawn',
  CONDITIONALLY_APPROVED: 'conditionally_approved',
} as const;

export { APPLICATION_STATUS_TYPE };
